import React, { useMemo } from 'react';

import { customTheme } from 'theme';

import { LineChart } from 'components/Visualization';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import {
  customizedXAxisTick,
  rotatedXAxisTick,
} from 'components/Visualization/Charts/utils';

import { CloudEventsSummaryChartProps } from '../../../types';

import {
  formatCloudEventsSummaryTime,
  getCloudEventsSummaryXAxisInterval,
} from './utils';

const TOTAL_REQUESTS = 'Total Requests';
const FAILED_REQUESTS = 'Failed Requests';

export const APICalls = ({
  summary,
  isHourly,
  summaryPeriod,
}: CloudEventsSummaryChartProps) => {
  const chartData = useMemo(
    () =>
      summary.data?.api_calls?.map(point => ({
        Date: formatCloudEventsSummaryTime(point),
        [TOTAL_REQUESTS]: Number(point.total_requests ?? 0),
        [FAILED_REQUESTS]: Number(point.failed_requests ?? 0),
      })) ?? [],
    [summary.data?.api_calls],
  );

  return (
    <DashboardWidget
      label="API Calls"
      subHeader={isHourly ? undefined : summaryPeriod ?? 'Last 7 days'}
      isLoading={summary.isLoading}
      noData={!chartData.length}
      paddingX={0}
      paddingBottom={1}
      content={
        <LineChart
          data={chartData}
          xField="Date"
          yField={[TOTAL_REQUESTS, FAILED_REQUESTS]}
          colorMap={{
            [TOTAL_REQUESTS]: customTheme.colors.blue['300'],
            [FAILED_REQUESTS]: customTheme.colors.red['300'],
          }}
          styles={{
            lineChart: {
              margin: { bottom: -15, left: 0 },
            },
            line: {
              strokeWidth: 2,
            },
            legend: {
              align: 'center',
              wrapperStyle: {
                left: 0,
                right: 0,
                width: '100%',
              },
            },
            xAxis: {
              axisLine: true,
              tickLine: true,
              tick: isHourly ? customizedXAxisTick : rotatedXAxisTick,
              height: isHourly ? 30 : 55,
              padding: { left: 16, right: 10 },
              interval: getCloudEventsSummaryXAxisInterval(
                isHourly,
                chartData.length,
              ),
            },
            yAxis: {
              axisLine: false,
              tickLine: false,
              //width: 65,
            },
          }}
        />
      }
    />
  );
};
